import { useContext } from "react";
import { Close, CheckCircleOutline } from "@mui/icons-material";
import { Button, Box, Paper, TableContainer, Typography } from "@mui/material";
import { ModuleContext } from "../../context/ModuleContext";
import { ManagedAccountContext } from "../../context/ManagedAccountContext";

const WSU_RED = "#A60F2D";

export const CreateManagedAccountConfirm = ({ text }) => {
  const { setModule } = useContext(ModuleContext);
  const { setManagedAccountModule } = useContext(ManagedAccountContext);

  const handleClose = () => {
    setModule((prev) => ({ ...prev, isVisible: false }));
    setManagedAccountModule((prev) => ({ ...prev, isOpen: false }));
  };

  return (
    <TableContainer component={Paper} elevation={2} sx={{ borderRadius: 2, overflow: "hidden" }}>
      <Box sx={{ backgroundColor: "#2e7d32", color: "white", px: 3, py: 2, display: "flex", alignItems: "center", gap: 1.5 }}>
        <CheckCircleOutline fontSize="small" />
        <Typography variant="subtitle2" fontWeight={700}>
          Account Created
        </Typography>
      </Box>

      <Box sx={{ px: 3, pt: 3, pb: 1 }}>
        <Typography variant="overline" sx={{ color: WSU_RED, fontWeight: 700, letterSpacing: 1.5 }}>
          Confirmation
        </Typography>
      </Box>

      <Box sx={{ px: 3, py: 2 }}>
        <Typography variant="body2" color="text.secondary">
          {text}
        </Typography>
      </Box>

      <Box sx={{ px: 3, pb: 4, display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="outlined"
          endIcon={<Close />}
          onClick={handleClose}
          sx={{ borderColor: "#ccc", color: "#666", "&:hover": { borderColor: "#aaa", backgroundColor: "#f9f9f9" } }}
        >
          Close
        </Button>
      </Box>
    </TableContainer>
  );
};
